import _ from 'lodash';

//General or Global selectors
export const notificationSelector = (state) => state.notifications.list;

//Auth selectors
export const authSelector = (state) => state.auth;
export const userSelector = (state) => state.auth.user;
export const authStatusSelector = (state) => state.auth.status;
export const authErrorSelector = (state) => state.auth.error;

//Token selectores
export const tokenSelector = (state) => state.token;

//Modal selectors
export const modalSelector = (state) => state.modal;
export const lastModalSelector = (state) => _.last(state.modal.stack);

//Files selectors
export const filesSelector = (state) => state.files;
export const bulkAddOkSelector = (state) => state.files.bulkAddOk;
export const exportFileOkSelector = (state) => state.files.exportFileOk;

//Main Data selectors
export const dataSelector = (state) => state.data;
export const clientsDataSelector = (state) => state.data.clientsData;
export const dataStatusSelector = (state) => state.data.status;
export const dataErrorSelector = (state) => state.data.error;
export const dataSyncSelector = (state) => state.data.sync;

export const filterByNameSelector = (state) => state.data.filters.filterByName;
export const filterByLastNameSelector = (state) => state.data.filters.filterByLastName;
export const filterByDocumentSelector = (state) => state.data.filters.filterByDocument;
export const filterByBatchSelector = (state) => state.data.filters.filterByBatch;
export const filterByOperationStatusSelector = (state) => state.data.filters.filterByOperationStatus;
export const filterByOperationTypesSelector = (state) => state.data.filters.filterByOperationTypes;
export const filterByOperationDateSelector = (state) => state.data.filters.filterByOperationDate;

// filtered Data Selectors
export const appliedFiltersSelector = (state) => state.data.appliedFilters;
export const appliedFilterByNameSelector = (state) => state.data.appliedFilters.filterByName;
export const appliedFilterByLastNameSelector = (state) => state.data.appliedFilters.filterByLastName;
export const appliedFilterByDocumentSelector = (state) => state.data.appliedFilters.filterByDocument;
export const appliedFilterByBatchSelector = (state) => state.data.appliedFilters.filterByBatch;
export const appliedFilterByOperationStatusSelector = (state) => state.data.appliedFilters.filterByOperationStatus;
export const appliedFilterByOperationTypesSelector = (state) => state.data.appliedFilters.filterByOperationTypes;
export const appliedFilterByOperationDateSelector = (state) => state.data.appliedFilters.filterByOperationDate;

//Loading
export const loadingStatus = (state) => state.data.loading;

//Download Links
export const downloadLinks = (state) => state.data.downloadLinks;